import { VoziqOfferFlow } from '../../common/voziq/voziqOfferFlow.service';
import { VoziqOffer, VoziqSaving } from '../../common/voziq/types';

const ShopCartHref = '/shop/cart';

class SettingsOffersController {
    public offers: VoziqOffer[];
    public savings: VoziqSaving[];
    public shopCartHref = ShopCartHref;

    constructor(private voziqOfferFlow: VoziqOfferFlow) {
        'ngInject';
    }

    public get hasContent() {
        return (this.offers || []).length > 0 || (this.savings || []).length > 0;
    }

    public reviewAndSign(offer: VoziqOffer) {
        this.voziqOfferFlow.open('account', undefined, offer.VoziqOfferID);
    }
}

export default {
    template: require('./offers.html'),
    bindings: {
        offers: '<',
        savings: '<'
    },
    controller: SettingsOffersController
};
